(() => {
  if (window.rmcfCatalogInitialized) return;
  window.rmcfCatalogInitialized = true;
  const root = window.Shopify?.routes?.root || '/';
  const features = document.querySelectorAll('.rmcf-shop-feature');
  if (features.length) {
    const url = new URL(`${root}collections/all`, location.origin);
    url.search = new URLSearchParams({sort_by: 'created-descending', page: '1', section_id: 'rmcf-recent-products'}).toString();
    // Same-origin cookies preserve the unpublished theme context. Fetch only public markup.
    fetch(url, {credentials: 'same-origin'}).then(response => {
      if (!response.ok) throw new Error('Recent products unavailable');
      return response.text();
    }).then(html => {
      const recent = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-rmcf-recent="true"]');
      if (!recent) return;
      const applyCue = () => document.querySelectorAll('.rmcf-shop-feature:not(.has-recent-products)').forEach(link => {
        link.classList.add('has-recent-products');
        link.querySelector('.rmcf-shop-new').hidden = false;
      });
      applyCue();
      // The native header inserts its mobile drawer from a template when opened.
      new MutationObserver(applyCue).observe(document.body, {childList: true, subtree: true});
    }).catch(() => { /* Retain the ordinary Shop link when the read is unavailable. */ });
  }
  class RmcfCatalogSort extends HTMLElement {
    connectedCallback() {
      const url = new URL(location.href);
      if (this.dataset.defaultSort === 'true' && !url.searchParams.has('sort_by')) {
        url.searchParams.set('sort_by', 'created-descending');
        location.replace(url);
        return;
      }
      this.onChange = event => {
        if (event.target.name !== 'sort_by') return;
        const next = new URL(location.href);
        next.searchParams.set('sort_by', event.target.value);
        next.searchParams.delete('page');
        // Preserve preview, view, filters and locale; Shopify sorts before pagination.
        location.assign(next);
      };
      this.addEventListener('change', this.onChange);
    }
    disconnectedCallback() { this.removeEventListener('change', this.onChange); }
  }
  if (!customElements.get('rmcf-catalog-sort')) customElements.define('rmcf-catalog-sort', RmcfCatalogSort);
})();
